import { IPictureInPicturePlugin } from './IPictureInPicturePlugin';
import {
  RatioChange_AutoCrop,
  AutoCropHandler,
  CleanScaleAndOffsetHandler,
} from '@wochitnpm/adjustasset';
export class AdjustOverlayAssetPlugin extends IPictureInPicturePlugin {
  constructor({ pipa }) {
    super({ pipa });
    this.BASE_ASPECT_RATIO = {
      width: app.ASSET_EDITOR_WIDTH,
      height: app.ASSET_EDITOR_HEIGHT,
    };
  }
  afterInsert({ overlay }) {
    super.afterInsert({ overlay });

    const themeInfo = this.pipa.getThemeInfo();
    if (!themeInfo) {
      return; // Can happen in unit tests
    }

    const sceneLayouts = themeInfo.sceneLayouts;
    const sceneLayoutObject = app.getSceneLayoutObject();
    const type = app.getOverlayLayoutAssetType(this.pipa.scene.type);

    if (!sceneLayoutObject[type]) {
      sceneLayoutObject[type] = _.flattenDeep(
        sceneLayouts.layoutCategories.map((sl) =>
          sl.sceneWindows.map((l) => l.layouts)
        )
      ).find((layout) => {
        return (
          layout.id ===
          sceneLayouts.defaultLayoutMap[
            sceneLayouts.defaultCategoryPerAssetType[type]
          ]
        );
      });
      app.setSceneLayoutObject(sceneLayoutObject);
    }

    if (!sceneLayoutObject[type]) {
      throw new Error('no default layout found');
    }
    overlay.sceneLayout = _.cloneDeepAndClean(sceneLayoutObject[type]);
    /**
     * on drop asset there are no scale and offset
     * there for auto crop base on current aspect ratio
     * @link https://wochit.atlassian.net/browse/DEV-9847
     */
    overlay.agd = new AutoCropHandler()
      .setNext(new CleanScaleAndOffsetHandler())
      .AdjustAsset({
        originalRatio: overlay.metadata,
        innerRatio: {
          height: app.ASSET_EDITOR_HEIGHT,
          width:
            app.ASSET_EDITOR_HEIGHT *
            app.ASPECT_RATIOS[app.currentAspectRatio].ratio,
        },
        baseRatio: {
          height: app.ASSET_EDITOR_HEIGHT,
          width: app.ASSET_EDITOR_WIDTH,
        },
      });

    if (Number(overlay.agd.scale) === 1) {
      overlay.agd.scale = null;
      overlay.agd.offset = null;
    }

    const collagePresets = themeInfo.collagePresets;
    if (collagePresets) {
      const shouldNotBeAddedToAgd = (field) => {
        return (
          field.type === 'DROPDOWN' &&
          field.defaultValue === field.optionThumbnails?.[0].id
        );
      };
      for (const preset of collagePresets) {
        const agdCo = {
          id: preset.id,
          layers: preset.layers,
          fields: [],
        };
        for (const field of preset.fields) {
          if (!shouldNotBeAddedToAgd(field)) {
            const newField = {
              name: field.name,
              type: field.type,
              value: '',
            };
            if (field.defaultValue || field.defaultValue === 0) {
              newField.value = field.defaultValue;
            }
            agdCo.fields.push(newField);
          }
        }
        if (agdCo.fields.length) {
          if (!overlay.agd.customOverlays) {
            overlay.agd.customOverlays = [];
          }
          overlay.agd.customOverlays.push(agdCo);
        }
      }
    }
  }

  afterReplaceOverlay({ overlay, oldOverlay }) {
    super.afterReplaceOverlay({ overlay, oldOverlay });

    const AdjustAsset = RatioChange_AutoCrop({
      innerRatio: this.pipa.scene.metadata,
    });

    overlay.sceneLayout = oldOverlay.sceneLayout;
    overlay.sceneAgd = oldOverlay.sceneAgd;

    // first adjust the asset
    overlay.agd = AdjustAsset.AdjustAssetPositionBase({
      assetPosition: app.getOverlayLayout(oldOverlay.sceneLayout),
      baseAspectRatio: this.BASE_ASPECT_RATIO,
      asset: overlay,
    });
    /**
     * second thing auto crop base on current aspect ratio.
     * @link https://wochit.atlassian.net/browse/DEV-9847
     **/
    overlay.agd = new AutoCropHandler()
      .setNext(new CleanScaleAndOffsetHandler())
      .AdjustAsset({
        originalRatio: overlay.metadata,
        innerRatio: {
          height: app.ASSET_EDITOR_HEIGHT,
          width:
            app.ASSET_EDITOR_HEIGHT *
            app.ASPECT_RATIOS[app.currentAspectRatio].ratio,
        },
        baseRatio: {
          height: app.ASSET_EDITOR_HEIGHT,
          width: app.ASSET_EDITOR_WIDTH,
        },
      });
    overlay.agd.customOverlays = oldOverlay.agd.customOverlays;
    return overlay;
  }
}
